import { Decimal } from 'decimal.js'

export const add = (a, b) => parseFloat(Decimal(a).add(b).valueOf())

export const minus = (a, b) => parseFloat(Decimal(a).minus(b).valueOf())

export const mul = (a, b) => parseFloat(Decimal(a).mul(b).valueOf())

export const div = (a, b) => parseFloat(Decimal(a).dividedBy(b).valueOf())
